export const YES_OR_NO_BINARY = {
    y: {
        en: 'Yes',
        es: 'Sí'
    },
    n: {
        en: 'No',
        es: 'No'
    }
} as Record<string, { en: string; es: string }>;

export const YES_OR_NO = {
    ...YES_OR_NO_BINARY,
    idk: {
        en: 'Don’t Know',
        es: 'No sé'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
